
import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  Modal,
} from "react-bootstrap";
export default function AddSchoolModal({ showSchoolModal, closeSchoolModal,
    setNewSchool, setSchoolErrors, newSchool, schoolErrors,cities,saveSchool }) {
    return (
        <Modal
            show={showSchoolModal}
            onHide={closeSchoolModal}
            dialogClassName="school-modal "
            centered

        >
            <Modal.Header closeButton className="m-3">
                <Modal.Title>Add School</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>

                    <Col md={6} className="mb-3">
                        <Form.Label>School Name</Form.Label>
                        <Form.Control
                            value={newSchool.name}
                            isInvalid={!!schoolErrors.name}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    name: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    name: null,
                                });
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.name?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={6} className="mb-3">
                        <Form.Label>City</Form.Label>
                        <Form.Select
                            value={newSchool.city_id}
                            isInvalid={!!schoolErrors.city_id}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    city_id: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    city_id: null,
                                });
                            }}
                        >
                            <option value="">Select City</option>

                            {cities.map((city) => (
                                <option
                                    key={city.id}
                                    value={city.id}
                                >
                                    {city.name}
                                </option>
                            ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.city_id?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={6} className="mb-3">
                        <Form.Label>School Code</Form.Label>
                        <Form.Control
                            value={newSchool.code}
                            isInvalid={!!schoolErrors.code}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    code: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    code: null,
                                });
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.code?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={6} className="mb-3">
                        <Form.Label>Principal Name</Form.Label>
                        <Form.Control
                            value={newSchool.principal_name}
                            isInvalid={!!schoolErrors.principal_name}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    principal_name: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    principal_name: null,
                                });
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.principal_name?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={6} className="mb-3">
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                            value={newSchool.contact_no}
                            isInvalid={!!schoolErrors.contact_no}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    contact_no: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    contact_no: null,
                                });
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.contact_no?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={6} className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            value={newSchool.email}
                            isInvalid={!!schoolErrors.email}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    email: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    email: null,
                                });
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.email?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={6} className="mb-3">
                        <Form.Label>Authority</Form.Label>
                        <Form.Select
                            value={newSchool.authority}
                            isInvalid={!!schoolErrors.authority}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    authority: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    authority: null,
                                });
                            }}
                        >
                            <option value="">Select Authority</option>
                            <option value="Govt">Govt</option>
                            <option value="Private">Private</option>
                            <option value="NGO">NGO</option>
                            <option value="Semi-Govt">Semi-Govt</option>
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.authority?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={6} className="mb-3">
                        <Form.Label>Level</Form.Label>
                        <Form.Select
                            value={newSchool.level}
                            isInvalid={!!schoolErrors.level}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    level: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    level: null,
                                });
                            }}
                        >
                            <option value="">Select Level</option>
                            <option value="Primary">Primary</option>
                            <option value="Middle">Middle</option>
                            <option value="High">High</option>
                            <option value="Elementary">Elementary</option>
                            <option value="Higher Secondary">Higher Secondary</option>
                            <option value="University">University</option>
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.level?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={12} className="mb-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={newSchool.address}
                            isInvalid={!!schoolErrors.address}
                            onChange={(e) => {
                                setNewSchool({
                                    ...newSchool,
                                    address: e.target.value,
                                });

                                setSchoolErrors({
                                    ...schoolErrors,
                                    address: null,
                                });
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {schoolErrors.address?.[0]}
                        </Form.Control.Feedback>
                    </Col>

                    <Col md={12}>
                        <Form.Check
                            type="switch"
                            label="Active"
                            checked={newSchool.status}
                            onChange={(e) =>
                                setNewSchool({
                                    ...newSchool,
                                    status: e.target.checked ? 1 : 0,
                                })
                            }
                        />
                    </Col>

                </Row>
            </Modal.Body>

            <Modal.Footer className="m-3">
                <Button variant="secondary" onClick={closeSchoolModal}>
                    Close
                </Button>

                <Button variant="primary" onClick={saveSchool}>
                    Save School
                </Button>
            </Modal.Footer>
        </Modal>
    )
}